// @flow

import * as React from 'react';

type Props = {
  className?: string,
  style?: Object,
  size?: number,
  color?: string,
};

const SplitPaneIcon = ({
  size = 12,
  style = {},
  className = '',
  color = 'currentColor',
}: Props) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M1.86 10h6.28C9.338 10 10 9.338 10 8.15v-6.3C10 .657 9.338 0 8.14 0H1.86C.662 0 0 .657 0 1.85v6.3C0 9.343.662 10 1.86 10zm.162-1.397c-.412 0-.625-.198-.625-.63V2.027c0-.438.213-.63.625-.63h2.314v7.206H2.022zm5.956-7.206c.407 0 .625.192.625.63v5.946c0 .432-.218.63-.625.63H5.664V1.397h2.314z"
      fill={color}
    />
  </svg>
);

export default SplitPaneIcon;
